import type { CMSImageBase } from '@/api/cms/base';

export type Category = {
  id: string;
  title: React.ReactNode;
  pathname: string;
  isAuthenticated?: boolean;
};

export enum TopicCardSize {
  SM = 'small',
  LG = 'large',
}

export enum TopicCardMode {
  DARK = 'dark',
  LIGHT = 'light',
}

export type Topic = {
  id: number;
  title: string;
  pathname: string;
  icon: CMSImageBase;
  cardSize?: TopicCardSize;
  cardMode?: TopicCardMode;
  isModal?: boolean;
  onClick?: () => void;
};

export type ProviderCustom = {
  id: string;
  title: string;
  pathname: string;
  icon: string;
  banner: string;
  isShowAll?: boolean;
};

export const RANDOMIZER_SUB_NAME = 'randomizer';
